import _defineProperty from "/src/main/react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
var _jsxFileName = "/src/main/react/src/main/app/components/common/PartnerSelector.js";
import React, { Component, Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Select, MenuItem, FilledInput, InputLabel, FormControl } from '@material-ui/core';
import { determineSelectedPartner } from "../../util/StorageUtil";
import { LOCAL_STORAGE_ITEM_NAMES } from "../domain/constants";
import { stringToObj } from "../../util/StringUtil";
const styles = theme => ({
  centeredContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto',
    maxWidth: '80vw',
    minWidth: '80vw'
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: '25vw',
    maxWidth: '33vw'
  }
});
class PartnerSelector extends Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "changeSelectedPartner", partner => {
      const selectedPartner = localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.selectedPartner);
      if (partner === selectedPartner) {
        return;
      }
      localStorage.setItem(LOCAL_STORAGE_ITEM_NAMES.selectedPartner, partner);
      this.setState({
        selectedPartner: partner
      });

      // force parent to re-render
      this.state.parentRef.state.partner = partner;
      this.state.parentRef.forceUpdate();
    });
    const partners = stringToObj(localStorage.getItem(LOCAL_STORAGE_ITEM_NAMES.partners));
    const _selectedPartner = determineSelectedPartner(partners);
    this.state = {
      selectedPartner: _selectedPartner,
      allPartners: partners,
      parentRef: props.parentRef
    };
  }
  render() {
    const _this$state = this.state,
      selectedPartner = _this$state.selectedPartner,
      allPartners = _this$state.allPartners;
    const classes = this.props.classes;
    const partnerKeys = allPartners != null ? Object.keys(allPartners) : null;
    return /*#__PURE__*/React.createElement(Fragment, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 13
      }
    }, allPartners != null && partnerKeys.length > 0 && /*#__PURE__*/React.createElement(FormControl, {
      variant: "filled",
      className: classes.formControl,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 17
      }
    }, /*#__PURE__*/React.createElement(InputLabel, {
      htmlFor: "partner-select",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 21
      }
    }, "Partner"), /*#__PURE__*/React.createElement(Select, {
      disableUnderline: true,
      value: selectedPartner.identifier,
      fullWidth: true,
      autoWidth: true,
      onChange: event => this.changeSelectedPartner(event.target.value),
      input: /*#__PURE__*/React.createElement(FilledInput, {
        name: "partner",
        id: "partner-select",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 49,
          columnNumber: 36
        }
      }),
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 47,
        columnNumber: 21
      }
    }, partnerKeys.map(partner => /*#__PURE__*/React.createElement(MenuItem, {
      value: partner,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 51,
        columnNumber: 29
      }
    }, allPartners[partner])))));
  }
}
export default withStyles(styles)(PartnerSelector);